import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=468d9fcf&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468d9fcf')) {
      api.createRecord('468d9fcf', component.options)
    } else {
      api.reload('468d9fcf', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=468d9fcf&", function () {
      api.rerender('468d9fcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F49R00KfE3Gz/JS/comp/ErrorMessage.vue"
export default component.exports